import React, { useEffect, useState } from 'react'
import queryString from 'query-string'
import { analytics } from 'firebase'
import Resizer from 'react-image-file-resizer'

import classes from './style.module.css'

import CurrencyName from '../../../elements/currency'
import Status from '../../../Status/Status'

import { strings } from '../../../../i18n'
import RenderAmounts from './elements/renderAmount'
import ModalWindow from '../../../Admin/elements/ModalWindow/modal'

import store from '../../../../redux'

import {
    fileInputAction,
    showExampleAction
} from '../../../../redux/stores/firstScreen/action'

import CardExample from '../../../../images/card2_2_f.png'
import VCExample from '../../../../images/icon/VCExample.png'

import CurrencySelectors from './elements/CurrencySelect'
import Payways from './elements/Payways'
import PaymentServices from './elements/PaymentServices'
import ScreenModal from './elements/ScreenModal/MainModal'

import Loader from '../../../../images/icon/loaderBlack.svg'


const { dispatch } = store

const RenderFirstScreen = (props) => {

    const state = store.getState().firstScreen
    const modalScreenState = store.getState().modalScreenStore

    const [externalID, setExternalId] = useState(false)

    useEffect(() => {
        const url = window.location.href
        const urlParamsString = url.slice((url.indexOf('?')) + 1)
        const urlParamsObj = queryString.parse(urlParamsString)

        const externalId = urlParamsObj.externalId || null
        setExternalId(externalId)
    }, [])

    const showExampleHandler = () => {
        dispatch(showExampleAction())
    }

    const fileInputHandler = async (state, event) => {
        const file = event.target.files[0]

        const fileData = await new Promise(resolve => {
            Resizer.imageFileResizer(file, 1920, 1080, 'JPEG', 80, 0, uri => { resolve(uri) }, 'base64')
        })
        dispatch(fileInputAction(state, fileData))
        showExampleHandler()
    }

    const renderModal = () => {
        if (!state.showExample) { return; }

        const images = [
            {
                src: CardExample,
                alt: strings('cardPhoto.physicalCard'),
            },
            // {
            //     src: VCExample,
            //     alt: strings('cardPhoto.virtualCard'),
            // }
        ]

        let currentData = new Date()
        currentData = `${currentData.getDate().toString().length === 1 ? '0' + currentData.getDate() : currentData.getDate()}.${(currentData.getMonth() + 1).toString().length === 1 ? '0' + (currentData.getMonth() + 1) : (currentData.getMonth() + 1)}.${currentData.getFullYear()}`

        return (
            <>
                <ModalWindow show={state.showExample} close={showExampleHandler} headerText={strings('cardPhoto.examples')} textCenter={true}>
                    <div className={classes.cardHeader}>
                        {strings('mobileBuy.modal.photoRequirements')}
                    </div>
                    <div className={classes.cardDescription}>
                        {strings('mobileBuy.modal.photoRequirementsDescription', { data: currentData })}
                    </div>
                    <div className={classes.upload} style={{ margin: '0 auto', paddingBottom: 20 }}>
                        <label htmlFor={'upload_photo'} className={classes.upload__label}>{strings('firstScreen.cardValid.chooseFile')}</label>
                        <input id={'upload_photo'} type="file" onChange={event => fileInputHandler(state, event)}
                            onClick={(e) => { e.target.value = '' }} />
                    </div>
                    {images.map((el) => {
                        return (
                            <>
                                <div className={classes.card__example} style={{ display: 'flex', alignItems: 'center', margin: '0 auto', width: '100%' }} >
                                    <img src={el.src} alt={el.alt} width={'100%'} style={{ maxWidth: 500, margin: '0 auto' }} />
                                </div>
                            </>
                        )
                    })}
                </ModalWindow>
            </>
        );
    }

    analytics().logEvent('open_DataInputScreen')
    analytics().setCurrentScreen('DataInputScreen')

    return (
        <>
            {!externalID && <Status screen={state.screen} />}
            <div className={!externalID ? classes.first__screen : classes.first__screen__mobile}>
                {state.loaderCurFrom ?
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 64 }}>
                        <h3>{strings('mobileExchanger.loading')}</h3>
                        <img style={{ paddingLeft: 10 }} src={Loader} alt='load' height={40} />
                    </div> :
                    <>
                        {!externalID &&
                            <CurrencySelectors state={state} />
                        }
                        {!externalID ?
                            <div>
                                <div className={classes.final}>
                                    <div className={classes.head}>
                                        <h3>{strings('firstScreen.paywayMethod')}</h3>
                                    </div>
                                    <Payways state={state} />
                                </div>
                                <div className={classes.head}>
                                    {state.payway ?
                                        <>
                                            <h3>{strings('firstScreen.exchangeFor').slice(0, strings('firstScreen.exchangeFor').indexOf(' ') + 1)} {<CurrencyName currencyCode={state.inCurrency} />} {strings('firstScreen.exchangeFor').slice(strings('firstScreen.exchangeFor').indexOf(' '), strings('firstScreen.exchangeFor').length)} {
                                                <CurrencyName currencyCode={state.outCurrency} />}</h3>
                                            <RenderAmounts state={state} />
                                            <PaymentServices state={state} />
                                        </>
                                        : null}
                                </div>
                            </div>
                            :
                            <div className={classes.head}>
                                {state.payway ?
                                    <>
                                        <h3>{strings('firstScreen.exchangeFor').slice(0, strings('firstScreen.exchangeFor').indexOf(' ') + 1)} {<CurrencyName currencyCode={state.inCurrency} />} {strings('firstScreen.exchangeFor').slice(strings('firstScreen.exchangeFor').indexOf(' '), strings('firstScreen.exchangeFor').length)} {
                                            <CurrencyName currencyCode={state.outCurrency} />}</h3>
                                        <RenderAmounts state={state} />
                                        <PaymentServices state={state} />
                                    </>
                                    : null}
                            </div>}
                    </>
                }
            </div>
            {renderModal()}
            {modalScreenState.show && <ScreenModal />}
        </>
    )
}

export default RenderFirstScreen

